import { h } from "preact";
import Required from "./Required";
import Description from "./Description";

const TextareaField = ({
  input,
  label,
  description,
  type,
  required,
  meta: { touched, error, warning }
}) => {
  let invalidObj = {};
  if (required) {
    invalidObj = {
      "aria-invalid": error && touched ? "true" : "false"
    };
  }
  return (
    <div class={touched && error ? "form-group has-error" : "form-group"}>
      <label for={input.name} class="form-label">
        {label}
        <Required required={required} />
      </label>
      <Description description={description} />
      <textarea
        class="form-input"
        aria-required={required ? "true" : "false"}
        id={input.name}
        {...input}
        type={type}
        rows="4"
        aria-label={label}
        {...invalidObj}
        aria-describedby={`${input.name}Error`}
      />
      {touched && error && (
        <p class="form-input-hint" id={`${input.name}Error`}>
          {error}
        </p>
      )}
    </div>
  );
};

export default TextareaField;



// WEBPACK FOOTER //
// ./components/fields/TextareaField.js